import React, { useContext } from "react";
import { RequiredMarkContext } from "components";
import styles from "./checkboxButtonValid.module.scss";
import { useCallback } from "react";
import Skeleton from "components/skeleton";
import clsx from "clsx";

const CheckboxButton = ({
	label,
	id,
	className,
	labelClassName,
	wrapperClassName,
	input,
	meta: { touched, error, warning },
	disabled,
	tabIndex,
	role,
	blurLoading,
	skeletonWidth,
	hideRequiredMark, //works only with RequiredMarkContext
}) => {
	const showRequiredMark =
		useContext(RequiredMarkContext) && !hideRequiredMark && !disabled;

	const checkSpanRequired = showRequiredMark ? (
		<span className={styles.spanRequired}>*</span>
	) : null;

	let disabledStyle = disabled ? styles.disabled : null;
	const checkRoleDisabled = role === "cdSetupDisabled" ? null : disabledStyle;

	const hasError =
		touched &&
		((error && <p className={styles.spanError}>{error}</p>) ||
			(warning && <p className={styles.spanError}>{warning}</p>));

	const labelBlock = label ? (
		<label htmlFor={id} className={clsx(checkRoleDisabled, labelClassName)}>
			{label}
			{checkSpanRequired}
		</label>
	) : null;

	const checkButton = (
		<div className={clsx(styles.wrappCheckButtonValid, wrapperClassName)}>
			<span className={className}>
				<input
					type="checkbox"
					{...input}
					id={id}
					checked={input.value}
					tabIndex={tabIndex}
					disabled={disabled}
				/>
				{labelBlock}
			</span>
			{hasError}
		</div>
	);

	const CheckButtonWithLoader = useCallback(
		({ checkButton }) =>
			blurLoading ? (
				<Skeleton variant="text" width={skeletonWidth} />
			) : (
				checkButton
			),
		[blurLoading, skeletonWidth],
	);

	return <CheckButtonWithLoader checkButton={checkButton} />;
};

export default CheckboxButton;
